import { createToken } from '@react-apps/core';
import type { ContentRepositoryImpl } from '../data/repositories/content.repository.impl';

export const ContentRepositoryToken =
  createToken<ContentRepositoryImpl>('ContentRepository');
